import { IconArchive, IconDotsVertical, IconEdit } from '@tabler/icons-react';

import { Button, Menu } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import { useDeleteApiDocumentsId } from '../../api/documents/documents.ts';
import { DocumentDto, ProjectDto } from '../../api/models';
import { useModal } from '../utils/useModal.tsx';
import DocumentEditModal from './DocumentEditModal.tsx';

interface DocumentDetailProps {
    document: DocumentDto;
    project: ProjectDto;
    refetch: () => void;
    onDocumentDeleted: (document: DocumentDto) => void;
    menuColor?: string;
}

const DocumentMenu = ({
    document,
    project,
    refetch,
    onDocumentDeleted,
    menuColor
}: DocumentDetailProps) => {
    const { mutateAsync: deleteDocument } = useDeleteApiDocumentsId();
    const { showDeleteConfirmModal } = useModal();
    const [editOpened, editModalActions] = useDisclosure();

    const deleteItem = () => {
        showDeleteConfirmModal(
            'Are you sure?',
            'This document will be deleted and will no longer available for access.',
            async () => {
                await deleteDocument(document);
                onDocumentDeleted(document);
                refetch();
            }
        );
    };

    return (
        <>
            <DocumentEditModal
                opened={editOpened}
                close={editModalActions.close}
                refetch={refetch}
                project={project}
                document={document}
            />
            <Menu shadow='md' width={200}>
                <Menu.Target>
                    <Button variant={'transparent'} color={menuColor}>
                        <IconDotsVertical />
                    </Button>
                </Menu.Target>
                <Menu.Dropdown>
                    <Menu.Item
                        onClick={editModalActions.open}
                        leftSection={<IconEdit />}
                    >
                        Edit Document
                    </Menu.Item>
                    <Menu.Item
                        onClick={deleteItem}
                        color={'red'}
                        leftSection={<IconArchive />}
                    >
                        Delete Document
                    </Menu.Item>
                </Menu.Dropdown>
            </Menu>
        </>
    );
};

export default DocumentMenu;
